<ng-container>
  <!-- botones -->
  <div class="row margen">
    <div class="col-12 panelBotones">

      <!-- Boton filtros -->
      <div class="botonesIzquierda">
        <button class="boton botonSM filledBlanco" (click)="AbrirPanel()" *ngIf="verpanel">
          <div class="botonFiltros">
            <div class="icono">
              <svg-icon class="iconoSVG" src="assets/Icono/filtros.svg" ></svg-icon>
            </div>
            <div>Filtros</div>
          </div>

        </button>
      </div>

      <div class="chips">
        <div class="chipsSeccion">
          <ng-container *ngTemplateOutlet="chipsTemplate;"></ng-container>
        </div>
      </div>

      <!-- Limpiar y consultar -->
      <div class="botonesDerecha">
        <div>
          <button class="boton botonSM filledBlanco" (click)="Limpiar()" *ngIf="verLimpiar">
            Limpiar
          </button>

          <div class="divisorH16"></div>

          <button class="boton botonSM filled" (click)="ActualizarConsulta(filtros)" *ngIf="verBotonConsultar">
            Consultar
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- chips -->
  <ng-template #chipsTemplate>
    <!--<div class="divisor8" *ngIf="tieneChips"></div>-->

    <div class="row margen">
      <div class="col-12">

        <!-- chips simples -->
        <ng-container *ngFor="let filtro of filtros" >
          <ng-container *ngIf="filtro.TipoFiltro != TipoFiltroEnum.DropDownMulti && filtro.TipoFiltro != TipoFiltroEnum.MultiSelect && sistemaService.TieneValor(filtro.Valor)">

            <div class="rowChip">
              <div class="chipFiltro" (click)="QuitarFiltro(filtro)">

                <!-- texto -->
                <div class="texto" [ngSwitch]="filtro.TipoFiltro">
                  <!-- Input -->
                  <ng-container *ngSwitchCase="TipoFiltroEnum.Input">
                    {{filtro.Titulo + ": " + filtro.Valor}}
                  </ng-container>

                  <!-- Dropdown -->
                  <ng-container *ngSwitchCase="TipoFiltroEnum.DropDown">
                    {{filtro.Titulo + ": " + (filtro.EtiquetasValor ? filtro.EtiquetasValor : '')}}
                  </ng-container>

                  <!-- Fecha -->
                  <ng-container *ngSwitchCase="TipoFiltroEnum.Fecha">
                    {{filtro.Titulo }} : {{ filtro.Valor | date : ('FormatoFecha' | translate) }}
                  </ng-container>

                  <!-- Fecha Rango -->
                  <ng-container *ngSwitchCase="TipoFiltroEnum.RangoFecha">
                   {{filtro.Titulo + ": "}} {{'Del' |translate}} {{filtro.Valor.Inicio | date : ('FormatoFecha' | translate)}} {{'Al' | translate}} {{filtro.Valor.Fin | date : ('FormatoFecha' | translate) }}
                  </ng-container>

                </div>

                <div class="quitar" *ngIf="!filtro.Obligatorio">
                  <span class="fa fa-times"></span>
                </div>

              </div>
            </div>

          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- chips multiples -->
    <ng-container *ngFor="let filtro of filtros">
      <ng-container *ngIf="(filtro.TipoFiltro == TipoFiltroEnum.DropDownMulti || filtro.TipoFiltro == TipoFiltroEnum.MultiSelect) && filtro.Valor.length > 0">
        <div class="row margen">
          <div class="col-12">
            <div class="">

              <div class="rowChip">
                <div class="chipFiltro etiquetaPropiedad">
                  <div class="texto">{{filtro.Titulo}}:</div>
                </div>
              </div>

              <div class="rowChip"  *ngFor="let opcion of filtro.Valor; let i = index">

                <!-- texto -->
                <div class="chipFiltro" (click)="QuitarFiltroMultiple(filtro, opcion, i)">
                  <div class="texto">
                    {{filtro.EtiquetasValor && filtro.EtiquetasValor[i] ? filtro.EtiquetasValor[i] : ''}}
                  </div>

                  <div class="quitar" *ngIf="!filtro.Obligatorio || (filtro.Obligatorio && filtro.Valor.length > 1)">
                    <span class="fa fa-times"></span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>



  </ng-template>

</ng-container>

<div *ngIf="panelAbierto">

  <div class="backdrop" (click)="CerrarPanel()"></div>

  <div class="panelFiltros animated {{animacion}}">

    <div class="encabezado">
      <div>
        <!-- back -->
        <div class="butonBack" (click)="CerrarPanel()">
          <div>
            <div>
              <span class="fa fa-chevron-left"></span>
            </div>
          </div>
        </div>

        <!-- Titulo -->
        <!-- back -->
        <div class="titulo">
          <div>
            <div class="icono">
              <svg-icon class="iconoSVG" src="assets/Icono/filtros.svg" ></svg-icon>
            </div>
            <div>
              Filtros
            </div>
          </div>
        </div>

        <!-- espacio -->
        <!-- back -->
        <div class="espacio"></div>
      </div>
    </div>

    <div class="contenido">

      <div class="row margen" *ngFor="let filtro of filtrosSeleccionados">
        <div class="col-12">

          <ng-container [ngSwitch]="filtro.TipoFiltro">

            <!-- Input -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.Input">
              <inputCustom [titulo]="filtro.Titulo" [disabled]="filtro.disabled" [(ngModel)]="filtro.Valor" [pattern]="filtro.Pattern"  [mensajeError]="filtro.MensajeError" [mask]="filtro.Mask ? filtro.Mask : false"
                           [errorActivo]="errorActivo" [verError]="filtro.Obligatorio"></inputCustom>
            </ng-container>

            <!-- DropDown -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.DropDown">
              <dropdownCustom [displayValor]="filtro.DisplayValor" [hidden]="filtro.Hidden" [disabled]="filtro.disabled" [valorName]="filtro.ValorName" [opciones]="filtro.Opciones" [buscar]="filtro.Buscar" (ngModelChange)="ModalChange(filtro, $event)"
                              [titulo]="filtro.Titulo" [(ngModel)]="filtro.Valor" [verError]="filtro.Obligatorio" [mensajeError]="filtro.MensajeError" [limpiarInput]="!filtro.Obligatorio" [errorActivo]="errorActivo"></dropdownCustom>
            </ng-container>

            <!-- DropDown Multi -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.DropDownMulti">
              <dropdownCustom [displayValor]="filtro.DisplayValor" [hidden]="filtro.Hidden" [valorName]="filtro.ValorName" [opciones]="filtro.Opciones" [multiSelect]="true" [buscar]="filtro.Buscar"
                              [titulo]="filtro.Titulo" [(ngModel)]="filtro.Valor" [verError]="filtro.Obligatorio" [mensajeError]="filtro.MensajeError" [limpiarInput]="true" [errorActivo]="errorActivo"></dropdownCustom>
            </ng-container>

            <!-- MultiSelect -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.MultiSelect">
              <multiSelect [titulo]="filtro.Titulo" [hidden]="filtro.Hidden" [opciones]="filtro.Opciones" [displayValor]="filtro.DisplayValor" [valorName]="filtro.ValorName" [(ngModel)]="filtro.Valor" [buscar]="filtro.Buscar"
                           [errorActivo]="errorActivo" [verError]="filtro.Obligatorio" ></multiSelect>
            </ng-container>

            <!-- Fecha -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.Fecha">
              <datePickerV2Custom [titulo]="filtro.Titulo" [(ngModel)]="filtro.Valor" [rangoFecha]="false" [hidden]="filtro.Hidden" [verError]="filtro.Obligatorio" [errorActivo]="errorActivo"></datePickerV2Custom>
            </ng-container>

            <!-- Fecha Rango -->
            <ng-container *ngSwitchCase="TipoFiltroEnum.RangoFecha">
              <datePickerV2Custom [titulo]="filtro.Titulo" [(ngModel)]="filtro.Valor" [rangoFecha]="true" [hidden]="filtro.Hidden" [verError]="filtro.Obligatorio" [errorActivo]="errorActivo"></datePickerV2Custom>
            </ng-container>


          </ng-container>

        </div>
      </div>

    </div>

    <div class="footer">

      <div>
        <button class="boton botonSM filledBlanco" (click)="Reestablecer()">
          Limpiar
        </button>
      </div>
      <div>
        <button class="boton botonSM filled" (click)="Aplicar()">
          Aplicar
        </button>
      </div>

    </div>

  </div>

</div>
